import flow01 from '@/assets/images/flow01.webp';
import flow02 from '@/assets/images/flow02.webp';
import flow03 from '@/assets/images/flow03.webp';
import flow04 from '@/assets/images/flow04.webp';

export default function FlowSection() {
  const steps = [
    {
      step: 'STEP 01',
      title: 'お問い合わせ・ご相談',
      description: 'まずはお電話やメールでお気軽にご相談ください。その際に不安なことなどございましたら何でもご質問ください。ご相談内容を元に、現地見積もりの日時を決めます。即日見積もりも可能です！',
      image: flow01,
      icon: 'ri-customer-service-2-line',
    },
    {
      step: 'STEP 02',
      title: 'お見積もり、ご契約',
      description: '現地の状態やお客様のご要望を詳しくお伺いし、その場でお見積もりをご提案いたします。お見積もり金額にご納得いただけない場合は、ここでキャンセルしていただいてOKです。その場合費用等は発生しません。また、しつこい勧誘等は一切ございませんのでご安心ください。',
      image: flow02,
      icon: 'ri-file-list-3-line',
    },
    {
      step: 'STEP 03',
      title: '搬出作業',
      description: '現場の状況を見て最善の片付け方法をお取り致します。基本的には大きなお荷物の搬出や、物の仕分け、ゴミの分別袋詰め作業などがメインの作業となります。作業当日は立ち会っていただいても、鍵をお預けいただき全てお任せいただいても大丈夫です。※作業が数日かかる場合は、その間鍵をお預かりする場合もございます。',
      image: flow03,
      icon: 'ri-truck-line',
    },
    {
      step: 'STEP 04',
      title: 'お支払い',
      description: '作業が完了いたしましたらお部屋の確認をお願いいたします。ご納得いただけましたらお支払い、もしくは請求書を発行させていただきます。同時買取をご希望の場合は合わせてご精算させていただきます。お見積り後の追加請求はいたしません。',
      image: flow04,
      icon: 'ri-money-dollar-circle-line',
    }
  ];

  return (
    <section id="flow" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-pink-100 px-4 py-2 rounded-full mb-4">
            <i className="ri-flow-chart text-primary"></i>
            <span className="text-primary font-semibold text-sm">ご利用の流れ</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            ゴミ屋敷の不用品回収の <strong className="text-primary">流れ</strong>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            お問い合わせから作業完了まで、お客様に安心していただけるよう丁寧にご説明いたします。
          </p>
        </div>

        {/* Steps */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16 relative">
          {/* Connector Line (Desktop) */}
          <div className="hidden lg:block absolute top-12 left-0 w-full h-0.5 bg-gray-200 -z-10 transform -translate-y-1/2"></div>
          
          {steps.map((item, index) => (
            <div key={index} className="bg-white rounded-xl border border-gray-100 shadow-sm hover:shadow-lg transition-all overflow-hidden flex flex-col">
              {/* 画像エリア */}
              <div className="relative h-48 w-full flex-shrink-0">
                <img src={item.image} alt={item.title} className="w-full h-full object-cover" />
                <div className="absolute top-3 left-3">
                  <span className="bg-primary text-white text-xs font-bold px-3 py-1 rounded-full tracking-wider">{item.step}</span>
                </div>
              </div>
              {/* テキストエリア */}
              <div className="p-6 flex flex-col flex-1">
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-10 h-10 bg-gradient-to-br from-primary to-pink-600 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className={`${item.icon} text-xl text-white`}></i>
                  </div>
                  <h3 className="text-lg font-bold text-gray-900">{item.title}</h3>
                </div>
                <p className="text-sm text-gray-600 leading-relaxed text-justify">
                  {item.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Notice Box */}
        <div className="bg-white rounded-2xl p-8 border-l-4 border-primary shadow-sm">
          <h3 className="text-xl font-bold text-gray-900 mb-6 flex items-center gap-2">
            <i className="ri-alert-line text-primary"></i>
            ご注意
          </h3>
          <ul className="space-y-4 text-sm text-gray-600 leading-relaxed">
            <li className="flex items-start gap-2">
              <span className="text-primary mt-1">•</span>
              <span>グッドサービスでは、遺品整理にて出た不用品は法令を遵守し、回収・処分のお手伝いを行なっております。</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-primary mt-1">•</span>
              <span>不用品は全てをゴミとして扱うのではなく各リサイクル品や資源（有価物）、一般ゴミと分別して、全て廃棄処分するより地球環境にとっても、お客様がお支払いするトータルコストの面においても最良の方法にて回収処理させていただきます。<br />資源項目：木類・衣類・金属類・家電類・プラスチック類ガラス類・陶器類・その他輸出可能品類<br /><span className="text-xs text-gray-500">※上記項目以外は一般ゴミとしての委託処理しております。</span></span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-primary mt-1">•</span>
              <span>有価物は、グッドサービスが引き上げ、回収、買取します。</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-primary mt-1">•</span>
              <span>その他一般ゴミ、粗大ゴミは分別、家の外への搬出を行い一般廃棄物収集業者へ委託して回収をします。（業者の委託申し込みやお支払いの代行は可能）</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-primary mt-1">•</span>
              <span>当社は一般社団法人遺品整理士認定協会加盟の遺品整理士の有資格者が在籍しております。</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-primary mt-1">•</span>
              <span>近年違法業者や悪徳業者が増加しておりますのでくれぐれもお気をつけ下さい。</span>
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
}
